module.exports = __webpack_public_path__ + "img/hasta-1.a8c8bf86.png";